import { getColor as getGlobalColor } from './global';
import { DATA_STATE_COMPLETED, DATA_STATE_SELECTED, DATA_STATE_UNAVAILABLE, INTERACTION_STATE_ACTIVE, INTERACTION_STATE_HOVER, } from '../../../../constants';
export function getColor(transformer) {
    const globalColor = getGlobalColor(transformer);
    return Object.freeze({
        text: {
            default: { value: globalColor.gray1000 },
            subtle: { value: globalColor.gray800 },
            attentional: { value: globalColor.gray1200 },
            inverted: { value: globalColor.white },
            brand: { value: globalColor.brand.mediumOrange },
        },
        feedback: {
            informative: {
                icon: { value: globalColor.blue700 },
            },
            positive: {
                icon: { value: globalColor.green700 },
            },
            warning: {
                icon: { value: globalColor.lightOrange700 },
            },
            negative: {
                icon: { value: globalColor.darkOrange700 },
            },
            cancelled: {
                icon: { value: globalColor.gray1000 },
            },
        },
        label: {
            dataStates: {
                [DATA_STATE_SELECTED]: { value: globalColor.gray1000 },
            },
        },
        button: {
            primary: {
                text: { value: globalColor.white },
                icon: { value: globalColor.white },
            },
            plain: {
                text: {
                    default: { value: globalColor.gray1000 },
                    interactionStates: {
                        [INTERACTION_STATE_ACTIVE]: {
                            value: globalColor.gray800,
                        },
                        [INTERACTION_STATE_HOVER]: {
                            value: globalColor.gray800,
                        },
                    },
                },
                icon: {
                    default: { value: globalColor.brand.mediumOrange },
                    interactionStates: {
                        [INTERACTION_STATE_ACTIVE]: {
                            value: globalColor.brand.mediumOrange,
                        },
                    },
                },
            },
            add: {
                text: { value: globalColor.gray1000 },
                icon: { value: globalColor.brand.mediumOrange },
            },
            secondary: {
                text: {
                    default: { value: globalColor.gray1000 },
                    interactionStates: {
                        [INTERACTION_STATE_ACTIVE]: {
                            value: globalColor.gray1200,
                        },
                        [INTERACTION_STATE_HOVER]: {
                            value: globalColor.gray1200,
                        },
                    },
                },
                icon: {
                    default: { value: globalColor.brand.mediumOrange },
                    interactionStates: {
                        [INTERACTION_STATE_ACTIVE]: {
                            value: globalColor.brand.mediumOrange,
                        },
                        [INTERACTION_STATE_HOVER]: {
                            value: globalColor.brand.mediumOrange,
                        },
                    },
                },
            },
        },
        listItem: {
            marker: {
                default: { value: globalColor.gray800 },
                attentional: { value: globalColor.gray1200 },
            },
        },
        link: {
            primary: {
                icon: {
                    default: { value: globalColor.brand.mediumOrange },
                    interactionStates: {
                        [INTERACTION_STATE_ACTIVE]: { value: globalColor.brand.mediumOrange },
                        [INTERACTION_STATE_HOVER]: { value: globalColor.brand.mediumOrange },
                    },
                },
                text: {
                    default: { value: globalColor.gray1200 },
                    interactionStates: {
                        [INTERACTION_STATE_ACTIVE]: { value: globalColor.gray1200 },
                        [INTERACTION_STATE_HOVER]: { value: globalColor.gray1200 },
                    },
                },
            },
            secondary: {
                icon: {
                    default: { value: globalColor.gray1000 },
                    interactionStates: {
                        [INTERACTION_STATE_ACTIVE]: { value: globalColor.gray1000 },
                        [INTERACTION_STATE_HOVER]: { value: globalColor.gray1000 },
                    },
                },
                text: {
                    default: { value: globalColor.gray1000 },
                    interactionStates: {
                        [INTERACTION_STATE_ACTIVE]: { value: globalColor.gray1000 },
                        [INTERACTION_STATE_HOVER]: { value: globalColor.gray1000 },
                    },
                },
            },
        },
        icon: {
            default: { value: globalColor.gray1000 },
            brand: { value: globalColor.brand.mediumOrange },
            inverted: { value: globalColor.white },
            dataStates: {
                [DATA_STATE_SELECTED]: { value: globalColor.brand.mediumOrange },
            },
        },
        form: {
            input: {
                icon: { value: globalColor.brand.mediumOrange },
            },
            select: {
                icon: { value: globalColor.brand.mediumOrange },
            },
            placeholder: { value: globalColor.gray800 },
            datepicker: {
                date: {
                    dataStates: {
                        [DATA_STATE_UNAVAILABLE]: { value: globalColor.gray800 },
                        [DATA_STATE_SELECTED]: { value: globalColor.gray1200 },
                    },
                },
            },
        },
        // `boxShadow`'s color if not specified defaults to `currentColor` which defaults to `color`
        shadow: { value: globalColor.gray1000 },
        pageHeader: {
            base: {
                title: { value: globalColor.brand.mediumOrange },
            },
        },
        pipeline: {
            stepTriggerIcon: { value: globalColor.brand.mediumOrange },
        },
        stepIndicator: {
            label: {
                dataStates: {
                    [DATA_STATE_COMPLETED]: { value: globalColor.gray1200 },
                },
            },
        },
    });
}
